import { render } from "./search.svg?vue&type=template&id=693a187a"
const script = {}
script.render = render

export default script